import React from "react";
import i18n from "../../../utilities/i18n";
import PasswordChangeForm from "../Components/PassWordChangeForm";

const ForgotPasswordChangeForm = () => {
    return (
        <div className="center-div">
        <PasswordChangeForm type="forgot" header={i18n.t('resetPassword.createrTextSuper')} />
        </div>
    );
};

export default ForgotPasswordChangeForm;
